/* @flow */

import React, { useEffect, useState } from 'react';

import LoadingComponent from 'components/loading';

import SubscriptionTab5GCComponent from './generalConditions';
import SubscriptionTab5PersonLegalFormComponent from './form';
import SubscriptionTab5ProcurationComponent from './procuration';

import CompanySubscriptionInfo from 'models/register/companySubscriptionInfo';

type SubscriptionTab5ComponentProps = {
  activeCompanyId: number;
  companySubscriptionInfo: CompanySubscriptionInfo;
  successHandler: () => void;
}

export default function SubscriptionTab5Component(props: SubscriptionTab5ComponentProps) {
  const { companySubscriptionInfo, successHandler } = props;
  const [isAdministrator, setIsAdministrator] = useState(companySubscriptionInfo.isAdministrator);

  const generalConditionsHandled =
    companySubscriptionInfo.generalConditionsSigned === true ||
    companySubscriptionInfo.generalConditionsNotNeeded === true;
  const autoAdvanceLegal = isAdministrator === true && generalConditionsHandled;

  // Admin declared inside this step while the GC are already signed or not needed:
  // advance instead of showing the dead-end GC screen (the wizard step skip only
  // covers administrators already known when the steps are built).
  useEffect(() => {
    if (autoAdvanceLegal) {
      successHandler();
    }
  }, [autoAdvanceLegal, successHandler]);

  if (isAdministrator === undefined || isAdministrator === null) {
    return (<SubscriptionTab5PersonLegalFormComponent successHandler={setIsAdministrator} />);
  }

  if (isAdministrator) {
    if (autoAdvanceLegal) {
      return (<LoadingComponent />);
    }

    return (
      <SubscriptionTab5GCComponent
        generalConditionsSigned={companySubscriptionInfo.generalConditionsSigned}
        generalConditionsNotNeeded={companySubscriptionInfo.generalConditionsNotNeeded}
        successHandler={successHandler}
      />
    );
  }

  return (
    <SubscriptionTab5ProcurationComponent
      successHandler={successHandler}
      hasSignedGC={companySubscriptionInfo.generalConditionsSigned}
    />
  );
}
